import React, { useEffect, useState } from "react";
import { ShieldAlert, Mail, LogOut } from "lucide-react";
import { clearToken } from "@/lib/tokenStore";

// Écran plein « Compte suspendu » avec le motif renvoyé par le serveur.
export default function AccountSuspendedScreen() {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const on = (e) => setMessage(e.detail?.message || "Compte suspendu");
    window.addEventListener("price:account-suspended", on);
    return () => window.removeEventListener("price:account-suspended", on);
  }, []);

  if (!message) return null;
  const reason = message.replace(/^Compte suspendu\s*[—-]\s*/, "").trim();

  const leave = async () => {
    try { await clearToken(); } catch (_) { /* ignore */ }
    setMessage(null);
    window.location.assign("/login");
  };

  return (
    <div className="fixed inset-0 z-[200] grid place-items-center bg-[#FFF8F1] p-6" data-testid="account-suspended-screen">
      <div className="w-full max-w-sm rounded-3xl bg-white p-6 text-center street-border street-shadow animate-in fade-in zoom-in-95 duration-300">
        <div className="mx-auto grid h-16 w-16 place-items-center rounded-2xl bg-primary text-primary-foreground street-border rotate-[-6deg]">
          <ShieldAlert className="h-8 w-8" strokeWidth={2.5} />
        </div>
        <h1 className="mt-5 font-[Outfit] text-[26px] font-black leading-tight">Compte suspendu</h1>
        <p className="mt-2 text-[14px] font-medium text-foreground/70">Ton compte Price a été suspendu par l&apos;équipe.</p>
        {reason && (
          <div className="mt-4 rounded-2xl bg-[#FFE9D6] p-3 text-left street-border-thin" data-testid="account-suspended-reason">
            <div className="text-[11px] font-black uppercase tracking-widest text-foreground/60">Motif</div>
            <div className="mt-1 text-[14px] font-bold">{reason}</div>
          </div>
        )}
        <a href="mailto:contact@pricecovoit.fr?subject=Compte%20suspendu"
          className="street-press mt-5 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-primary font-[Outfit] font-black text-primary-foreground street-border street-shadow-sm"
          data-testid="account-suspended-contact">
          <Mail className="h-4 w-4" strokeWidth={2.75} />Contacter le support
        </a>
        <button type="button" onClick={leave}
          className="street-press mt-3 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-white font-[Outfit] font-black street-border-thin"
          data-testid="account-suspended-logout">
          <LogOut className="h-4 w-4" strokeWidth={2.75} />Se déconnecter
        </button>
      </div>
    </div>
  );
}
